import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { AddProWakel } from "./Context/AddProWakel";
import ErrorBoundary from "./Components/shared/ErrorBoundary";

ReactDOM.render(
  <ErrorBoundary>
    <AddProWakel>
      <App />
    </AddProWakel>
  </ErrorBoundary>,
  document.getElementById("root")
);

serviceWorker.unregister();
